import Vue from 'vue'
import Vuex from 'vuex'
import { generateVuexStoreModuleConfiguration } from 'vuex-module-configuration-composer'

Vue.use(Vuex)

const context = require.context('./modules', true, /index\.js$/)

export default new Vuex.Store(generateVuexStoreModuleConfiguration(context))
